import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  listContainer: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.primary.lighter,
    borderRadius: '10px',
    marginTop: '4px',
    padding: '10px',
  },
  add: {
    marginLeft: '10px',
  },
}));
